export default __webpack_public_path__ + "static/media/loadingmobile.68806513.gif";